import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const STOREFRONT_LOCALE_KEY = 'seenoty-storefront-locale';

export const storefrontI18n = createInstance();

const saved =
  typeof window !== 'undefined' ? window.localStorage.getItem(STOREFRONT_LOCALE_KEY) : null;
const initialLng = saved === 'ar' || saved === 'en' ? saved : 'en';

void storefrontI18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLng,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function syncDocumentLangDir(lng: string): void {
  if (typeof document === 'undefined') return;
  const isRtl = lng === 'ar';
  document.documentElement.lang = lng;
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.documentElement.classList.toggle('lang-ar', isRtl);
}

export function resetDocumentLangDir(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = 'en';
  document.documentElement.dir = 'ltr';
  document.documentElement.classList.remove('lang-ar');
}
